export default "__VITE_ASSET__3dba66cd__"